import { Field } from 'formik';
import { TextField } from 'formik-mui';
import { useTranslation } from 'react-i18next';

import {
  BankSelect,
  FormControls,
  FormikArray,
  PaymentTypeSelect,
} from 'components';
import { TranslationNamespace } from 'i18n';

type ItemProps = {
  index: number;
};

const SciPaymentConfigItem: React.FC<ItemProps> = ({ index }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });

  return (
    <FormControls sx={{ flex: 1 }}>
      <PaymentTypeSelect
        name={`sciPaymentConfigs[${index}].paymentTypeId`}
        label={t('fields.sci_payment_type')}
        fullWidth
        required
      />
      <BankSelect
        label={t('fields.sci_payment_bank')}
        name={`sciPaymentConfigs[${index}].bankId`}
        noneOption
      />
      <Field
        component={TextField}
        label={t('fields.sci_payment_comment')}
        name={`sciPaymentConfigs[${index}].comment`}
        size="small"
        fullWidth
      />
    </FormControls>
  );
};

export const SciPaymentTypeConfigs: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });

  return (
    <FormikArray
      addItemLabel={t('buttons.add_sci_payment_type')}
      name="sciPaymentConfigs"
      removable
      defaultValue={{ paymentTypeId: '', bankId: '', comment: '' }}
      ItemComponent={SciPaymentConfigItem}
    />
  );
};
